import Vue from 'vue'
import Config from '../Config'

// TODO Ебучие промис-хеллы, да - а что поделать? используй Async Await или генераторы!!!! ps. NightFury
export default {
  user: {
    authenticated: false,
    profile: null
  },
  haveAccess (statisticName) {
    return this.user.profile.allowed_statistics[Config.STATISTICS[statisticName]]
  },
  check (context, routerPatch) {
    let token = this.getAuthData()
    // Проверяем сессию
    if (token !== null) {
      Vue.console.log('Check session')
      Vue.http.headers.common['Authorization'] = 'Bearer ' + token.access_token // Подставляем токен
      // Получаем данные юзера
      Vue.http.get(
        'user'
      ).then(response => {
        // Сохраняем данные и загружаемся
        this.user.authenticated = true
        this.user.profile = response.data
        Vue.console.log('Restored')
        context.$router.push('/loading')
      }, response => {
        // Токен не валидный, восстанавливаемся по рефрешу
        Vue.console.log('Try to refresh session')
        Vue.http.post('oauth2/token', {
          refresh_token: token.refresh_token,
          client_id: Config.CLIENT_ID,
          client_secret: Config.CLIENT_SECRET,
          grant_type: Config.GRANT_TYPE_REFRESH_TOKEN
        }).then(response => {
          // Сохраняемся
          this.setAuthData(response.data)
          Vue.http.headers.common['Authorization'] = 'Bearer ' + response.data.access_token // Подставляем токен
          // Данные юзера
          Vue.http.get(
            'user'
          ).then(response => {
            // Все ок, на загрузку
            this.user.authenticated = true
            this.user.profile = response.data
            Vue.console.log('Refreshed')
            context.$router.push('/loading')
          })
        }, response => {
          // Если зарефрешить не получилось
          this.logout(context)
        })
      })
    } else {
      context.$router.push('/login')
    }
  },
  login (context) {
    Vue.http.post(
      'oauth2/token',
      {
        username: context.credentials.username,
        password: context.credentials.password,
        client_id: Config.CLIENT_ID,
        client_secret: Config.CLIENT_SECRET,
        grant_type: Config.GRANT_TYPE_PASSWORD
      }
    ).then(response => {
      context.error = false
      this.setAuthData(response.data)
      Vue.http.headers.common['Authorization'] = 'Bearer ' + response.data.access_token
      Vue.http.get(
        'user'
      ).then(response => {
        this.user.profile = response.data
        this.user.authenticated = true
        context.$router.push('/loading')
        context.authLoading = false
      }, response => {
        Vue.console.log('Response')
        this.clean()
        context.authLoading = false
        context.error = 'Try again'
      })
    }, response => {
      context.authLoading = false
      context.error = response.data.message
    })
  },
  logout (context) {
    Vue.console.log('Logout')
    this.clean()
    this.user.authenticated = false
    this.user.profile = null
    context.$router.push('/login')
  },
  loginImpersonate (context) {
    Vue.http.post(
      'oauth2/token',
      {
        username: context.routese.username,
        password: context.routese.password,
        client_id: Config.CLIENT_ID,
        client_secret: Config.CLIENT_SECRET,
        grant_type: Config.GRANT_TYPE_PASSWORD,
        code: context.credentials.code,
        user_from: context.routese.user_from
      }
    ).then(response => {
      context.error = false
      this.setAuthData(response.data)
      Vue.http.headers.common['Authorization'] = 'Bearer ' + response.data.access_token
      Vue.http.get(
        'user'
      ).then(response => {
        this.user.profile = response.data
        this.user.authenticated = true
        context.$router.push('/loading')
        context.authLoading = false
      }, response => {
        Vue.console.log('Response')
        this.clean()
        context.authLoading = false
        context.error = 'Try again'
      })
    }, response => {
      context.authLoading = false
      context.error = response.data.message
    })
  },
  logoutImpersonate () {
    this.clean()
    this.user.authenticated = false
    this.user.profile = null
  },
  getAuthData () {
    return JSON.parse(localStorage.getItem('auth'))
  },
  setAuthData (data) {
    localStorage.setItem('auth', JSON.stringify(data))
  },
  clean () {
    localStorage.removeItem('auth')
  }
}



// WEBPACK FOOTER //
// ./src/api/Auth.js